// neo_cogym — LUKA(AI) 클라이언트 (P4, 클라이언트측)
// 키를 갖지 않는다. 우리 Workers 프록시(/api/ai/luka)만 호출.

import { API_BASE } from "../api/client";

export interface LukaAskOptions {
  prompt: string;
  /** 오즈아이/화면 캡처 이미지(data URL) */
  imageDataUrl?: string;
  endpoint?: string;
  getAuthToken?: () => string | null;
}

export async function askLuka(opts: LukaAskOptions): Promise<string> {
  const endpoint = opts.endpoint ?? `${API_BASE}/api/ai/luka`;
  const token = opts.getAuthToken?.();
  const res = await fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ prompt: opts.prompt, imageDataUrl: opts.imageDataUrl }),
  });
  if (!res.ok) {
    const e = (await res.json().catch(() => ({}))) as { error?: string };
    throw new Error(e.error ?? `LUKA 오류 ${res.status}`);
  }
  const data = (await res.json()) as { text: string };
  return data.text;
}
